<template>
    <div class="content-wapper">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">检验检测服务</el-breadcrumb-item>
                    <el-breadcrumb-item>特种设备检测</el-breadcrumb-item>
                </el-breadcrumb>
                <!--
                <span>当前位置: &nbsp;&nbsp;</span>
                <span>检验检测服务 </span>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="refresh" class="router"> 特种设备检测</el-link>
                -->
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" class="left-content">
                <el-row class="left-img">
                    <img src="@/assets/images/jyjcfw/tzsbjc/zctp.jpg"/>
                </el-row>
                <el-row class="top">
					<el-col :span="24" >
						<el-row>
							<el-col :span="24" class="title-content">
								<span  style="color: #FFE300">
								    特种设备作业人员考试专栏
								</span>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24" class="ewm">
								<el-row>
									<el-col :span="12" >
										<div class="ewmbg">
											<img src="@/assets/images/jyjcfw/tzsbjc/ewm.png" width="59" height="59" style="margin-top: 1px"/>
										</div>
										<span style="font-size: 0.75rem;">请扫码预约</span>
									</el-col>
									<el-col :span="12" class="tzgg">
										<span>通知公告</span>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
						<el-row class="button-menu-row">
							<el-col :span="10" class="button-menu-1">
								<span @click="openPage('http://218.57.139.17:8899/ZYRY/','1')">考试报名</span>
							</el-col>
							<el-col :span="10" class="button-menu-2">
								<span @click="openPage('http://ry.ts365.org/ks/Exam2/Default.htm','2')">查询考试成绩</span>
							</el-col>
						</el-row>
						
						<el-row class="button-menu-row" style="margin-top: 1rem">
							<el-col :span="10" class="button-menu-1">
								<span @click="openPage('http://ry.ts365.org/ks/Exam2/Default.htm','3')">打印考试准考证</span>
							</el-col>
							<el-col :span="10" class="button-menu-2">
								<span @click="openPage('http://ry.ts365.org/ks/Exam2/Default.htm','4')">模拟考试</span>
							</el-col>
						</el-row>
					</el-col>
                </el-row>
                <el-row class="bottom">
					<el-col :span="24" >
						<el-row>
							<el-col :span="24" class="title-content">
								<span style="color: #FFE300">
								    特种设备检验专栏
								</span>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24" class="bottom-menu">
								<span   @click="openSsoPage('os_tzsbjy')">
								    特种设备用户网上报检
								</span>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24" class="bottom-menu">
								<span @click="openPage('http://scjgjtjy.weihai.cn/dybg/login/authLogin','6')">
								    检验报告网上打印
								</span>
							</el-col>
						</el-row>
					</el-col>
                </el-row>
				<el-row class="bottom bottom2">
					<el-col :span="24" >
						<el-row>
							<el-col :span="24" class="title-content">
								<span style="color: #FFE300">
								    下载专栏
								</span>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24" class="bottom-menu">
								<span   @click="openDownFile()">
									2022特种设备检验申(约)请表
								</span>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
            </el-col>
            <el-col :span="18" class="right-box-row" style="height: 36.625rem" >

                <el-row class="right-box-row-title">
                    考试通知公告
                </el-row>

                <el-row>
                    <el-table v-loading="loading" :data="list" :show-header="false" tooltip-effect="light" >
                        <el-table-column align="left" :show-overflow-tooltip="true" prop="title" class-name="title">
                            <template slot-scope="scope">
                                <i class="el-icon-menu" style="margin-right: 0.625rem;"></i>
                                <el-link :underline="false" @click="openDetail(scope.row)">{{ scope.row.title }}
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="fbTime" :width="180" >
							<template slot-scope="scope">
								<span>{{ parseTime(scope.row.fbTime, '{y}-{m}-{d}') }}</span>
							</template>
						</el-table-column>
                    </el-table>
                    <pagination
                            v-show="total>0"
                            :total="total"
                            :page.sync="queryParams.pageNum"
                            :limit.sync="queryParams.pageSize"
                            @pagination="getList"
                    />
                </el-row>
                
            </el-col>
        </el-row>

    </div>
</template>

<script>
	import {
		listTzsbTzgg,
	} from "@/api/jyjcfw/tzsbTzgg";
	import {updatePvNum} from "@/api/itempv/pv";
	import { getSsoDesInfo, } from "@/api/zlts/jlfw/jljgxx";
    export default {
        name: "tzsbjc",
        data() {
            return {
                // 遮罩层
                loading: false,
                // 总条数
                total: 0,
                list:[],
                queryParams:{
                    pageNum:1,
                    pageSize:10
                },
				ssoOtherOsInfo:{},
            }
        },
        created() {
            this.getList();
        },
        methods: {
            openPage(pageUrl,type){
            	let item_key="";
            	if(type=='1'){
            		//考试报名 zlts_tzsbjy_ksbm
					item_key='zlts_tzsbjy_ksbm';
				}else if(type=='2'){
            		//查询考试成绩 zlts_tzsbjy_cxkscj
					item_key='zlts_tzsbjy_cxkscj';
				}else if(type=='3'){
            		//打印考试准考证 zlts_tzsbjy_dykszkz
					item_key='zlts_tzsbjy_dykszkz';
				}else if(type=='4'){
            		//模拟考试 zlts_tzsbjy_mnks
					item_key='zlts_tzsbjy_mnks';
				}else if(type=='5'){
					//特种设备用户网上报检 zlts_tzsbjy_tzsbyhwsbj
					item_key='zlts_tzsbjy_tzsbyhwsbj';
				}else if(type=='6'){
					//检验报告网上打印 zlts_tzsbjy_jybgwsdy
					item_key='zlts_tzsbjy_jybgwsdy';
				}
				updatePvNum(item_key).then(response => {
					//pv 点击知识产权质押融资
				});
				this.utils.windowOpen(pageUrl)
            },
			openNewPage(url){
				this.utils.windowOpen(url);
			},
			openSsoPage(syscode){
				//----【】需要修改为recid
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (this.utils.isLoginTimeout()) {
					//特种设备需要判断个人信息是否已经完善
					if(ssessionLoginUser.user.ftype=='1'){
						if(ssessionLoginUser.user.county == null ||  ssessionLoginUser.user.county=='' || ssessionLoginUser.user.county==undefined || ssessionLoginUser.user.county == '0'){
							this.msgWarning("您尚未完善信息，请进入个人工作室完善信息！");
							this.toPage('/qygzs/index');
							return false;
						}
					}
					this.ssoOtherOsInfo.syscode = syscode;
					this.ssoOtherOsInfo.uuid = ssessionLoginUser.ywFwjg.uuid;
					this.ssoOtherOsInfo.usertype = ssessionLoginUser.user.ftype;
					this.ssoOtherOsInfo.loginname = ssessionLoginUser.user.realName;
					this.ssoOtherOsInfo.entname = ssessionLoginUser.user.corname;
					this.ssoOtherOsInfo.entnumber = ssessionLoginUser.user.cornumber;
					this.ssoOtherOsInfo.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
					getSsoDesInfo(this.ssoOtherOsInfo).then(response => {
						this.openNewPage(response.url + "?syscode=" + syscode + "&sign=" +
							response.sign);
						return true;
					});
				} else {
					if(ssessionLoginUser == null || ssessionLoginUser == undefined){
						window.location.href = this.Config.sdtyrzfwLoginUrl;
					}else{
						let ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
						this.$confirm(
								'登录请求已过期，您可以继续留在该页面，或者重新登录?',
								'系统提示', {
									confirmButtonText: '重新登录',
									cancelButtonText: '取消',
									type: 'warning'
								}
						).then(() => {
							this.logout(ywFwjgRecid)
						})
					}

				}
			},
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getList();
            },
            getList(){
				this.loading = true;
				listTzsbTzgg(this.queryParams).then(response => {
					this.list = response.rows;
					this.total = response.total;
					this.loading = false;
				});
            },
            openDetail(item) {
				updatePvNum("zlts_tzsbjy_tzgg").then(response => {
					//pv 点击特种设备通知公告
				});

				this.utils.windowOpen('/main/jyjcfw/tzsbjc/detail' + '/' + item.recid);
            },
			openDownFile () {
				window.location.href = 'https://zhjg.weihai.cn/service/static/file.doc'

			}
        }
    }
</script>

<style scoped>
	.content-wapper{
		margin-top: 5px;
		padding: 10px;
	}
	.navigation{
		padding:20px 15px;
		line-height: 20px;
		height: 60px;
		background-color: #F5F5F5;
		margin-bottom: 15px;
	}
    .left-img img{
        width: 100%;
    }
    .menu-box{
        background-image: url('../../../../assets/images/jyjcfw/tzsbjc/zclmbj.png');
        height: 244px;
        /*width: 365px;*/
        background-size:100% 100%;
        background-repeat: no-repeat;
    }
    .zclmdbtStyle{
        background-image: url('../../../../assets/images/jyjcfw/tzsbjc/zclmdbt.png');
        height: 52px;
        width: 272px;
        background-size:80% 80%;
        background-repeat: no-repeat;
        margin:10px 50px 10px 50px;
        position: relative;
    }

    .tzsb-content{
        color: white;
        position: absolute;
        top: 18px;
        left: 10px;
        width: 200px;
    }

    .bottom-content{
        width: 260px;
        height: 170px;
        margin:10px 30px 0 30px;
        position: absolute;
        bottom: 10px;
        background-color: white;
    }

    .smtzgg-content{
        width: 240px;
        height: 90px;
        background-color: whitesmoke;
        left: 10px;
        top: 5px;
    }

    .smimg-content{
        background-image: url('../../../../assets/images/jyjcfw/tzsbjc/zcewmbj.png');
        height: 61px;
        width: 62px;
        margin: 5px;
        background-size:100% 100%;
        background-repeat: no-repeat;
    }

    .sm-content{
        width: 62px;
        font-size: xx-small;
        margin: 0 0 10px 5px;
    }
    .tzgg-content{
        font-size: 20px;
        font-weight: bold;
        position: absolute;
        top: 25px;
        left: 35px;
    }

    .top-button{
        background-color:oldlace;
        color: #a95812;
        font-weight: bold;
        width: 115px;
        margin-top: 5px;
        font-size: 14px;
        padding: 5px 10px 5px 10px;
    }

    .bottom-button{
        background-color:oldlace;
        color: #a95812;
        font-weight: bold;
        width: 240px;
        margin-top: 5px;
        font-size: 14px;
        padding: 5px 10px 5px 10px;
    }

    /deep/.el-menu{
        text-align: left;
        background-color:#FAFAFA;
        border:0;
    }
    .right-box{
        padding-left: 10px;
    }
    .right-box-row{
        border: 1px solid #cccccc;
        padding: 10px 15px;
    }
    .right-box-row-tip{
        padding: 10px;
        background-color: #FBF8E5;
    }

    .right-box-row-title{
        padding: 15px 0;
        text-align: left;
        color: #1c84c6;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        margin-bottom: 20px;
    }
	.left-content{
		padding: 0 1rem;
	}
	.top{
		background-color: #84afd2;
		min-height: 15.4rem;
	}
	.bottom{
		background-color: #84afd2;
		min-height: 8rem;
		margin-top: 0.625rem;
	}
	.bottom2{
		min-height: 6rem;
	}
	.title-content{
		color: #FFFFFF;
		font-size: 1.125rem;
		font-weight: 600;
		padding-top: 0.625rem;
	}
	.ewm{
		background-color: #fafff8;
		min-height: 6rem;
		width: 90%;
		margin:0.8rem 5%;
	}
	.button-menu-row{
		width: 100%;
		min-height: 2rem;
	}
	.button-menu-1{
		background-color: #fafff8;
		min-height: 2rem;
		margin-left: 0.892187rem;
		line-height: 2rem;
		font-weight: 600;
		cursor: pointer;
	}
	.button-menu-2{
		background-color: #fafff8;
		min-height: 2rem;
		margin-left: 1.1875rem;
		line-height: 2rem;
		font-weight: 600;
		cursor: pointer;
	}
	.button-menu-1:hover{
		color: #409EFF;
	}
	.button-menu-2:hover{
		color: #409EFF;
	}
	.ewmbg{
		background-image: url('../../../../assets/images/jyjcfw/tzsbjc/ewmbg.png');
		width: 4rem;
		margin-left: 2rem;
		margin-top: 0.5rem;
	}
	.tzgg{
		height: 5.625rem;
		line-height: 5.625rem;
		font-size: 1.125rem;
		font-weight: bold;
	}
	.bottom-menu{
		background-color: #fafff8;
		min-height: 2rem;
		margin: 2% 5%;
		line-height: 2rem;
		font-weight: 600;
		cursor: pointer;
		width: 90%;
		text-align: left;
		padding-left: 1rem;
	}
	
	.bottom-menu:hover{
		color: #409EFF;
	}
</style>